<template>
  <el-row :gutter="20" class="top-block">
    <Breadcrumb :route="this.$route"></Breadcrumb>

    <!-------------------------------------------------------------------->
    <!-- action -->
    <!-------------------------------------------------------------------->
    <el-col :xs="24" :sm="24" :lg="16">
      <el-select :xs="24" v-model="queryField" placeholder="選擇搜尋條件" style="padding: 0 0 0 20px">
        <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <el-input v-model="keyword" style="width: 200px" placeholder="輸入關鍵字" class="ml-10"
                suffix-icon="el-icon-search"></el-input>

      <el-button type="primary" @click.prevent="search" class="ml-10">查詢</el-button>
      <el-button type="normal" @click.prevent="clearQuery" class="ml-10">清除條件</el-button>
    </el-col>

    <el-col :xs="24" :sm="24" :lg="8" class="text-right">
      <el-button type="warning" @click.prevent="pickCustomer">挑選管轄客戶</el-button>
      <!--      <el-button type="warning" @click.prevent="setupSales" class="ml-20 mt-10">儲存設定</el-button>-->
    </el-col>


    <!-------------------------------------------------------------------->
    <!-- table -->
    <!-------------------------------------------------------------------->
    <el-col :xs="24" :sm="24" :lg="24">
      <el-main>
        <el-table :data="currentCustomerData" empty-text="無資料"
                  stripe header-row-class-name="headerStyle"
                  @selection-change="handleSelctionChange">
          <!--          <el-table-column type="selection" width="55">-->
          <!--          </el-table-column>-->
          <el-table-column prop="custNo" label="客戶編號" width="80">
          </el-table-column>
          <el-table-column prop="name" label="客戶">
            <template slot-scope="props">
              <p>{{ props.row.company }}</p>
              <p style="font-weight: 500">{{ props.row.name }}</p>
              <p>{{ props.row.phone1 }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="custType" label="身份別">
          </el-table-column>
          <el-table-column prop="haveCatalog" label="紙本型錄">
          </el-table-column>
          <el-table-column label="區域">
            <template slot-scope="props">
              {{props.row.area1Name}}/{{props.row.area2Name}}/{{props.row.area3Name}}
            </template>
          </el-table-column>
          <el-table-column type="expand" label="更多訊息..." width="100">
            <template slot-scope="props">
              <p class="mt-10">地址: {{ props.row.address }}</p>
              <p class="mt-10">電話2: {{ props.row.phone2 }}</p>
              <p class="mt-10">傳真: {{ props.row.fax }}</p>
              <p class="mt-10">統編: {{ props.row.vat }}</p>
              <p class="mt-10">email: {{ props.row.email }}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-popconfirm
                  class="ml-10 popconfirm-bg"
                  title="確定不負責此客戶了嗎?"
                  confirm-button-text="確定"
                  cancel-button-text="取消"
                  icon="el-iconf-info"
                  icon-color="red"
                  @confirm="handleDelete(scope.row.id)"
              >
                <el-button type="danger" slot="reference">解除 <i class="el-icon-delete"></i></el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>


      </el-main>
    </el-col>

    <!-------------------------------------------------------------------->
    <!-- dialog -->
    <!-------------------------------------------------------------------->

    <el-dialog title="挑選管轄客戶"
               :visible.sync="dialogFormVisible"
               :width="dw">
      <el-form :model="form" ref="userForm" label-width="80px">
        <el-row>
          <el-col :xs="24" :sm="24" :lg="8">
            <el-select v-model="form.area1" placeholder="地區" @change="loadArea2()" class="mr-10">
              <el-option
                  v-for="item in areaOption1"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-col>
          <el-col :xs="24" :sm="24" :lg="8">
            <el-select v-model="form.area2" placeholder="城市" @change="loadArea3()" class="mr-10">
              <el-option
                  v-for="item in areaOption2"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-col>
          <el-col :xs="24" :sm="24" :lg="8">
            <el-select v-model="form.area3" placeholder="區域" @change="listArea3Customer" class="mr-10">
              <el-option
                  v-for="item in areaOption3"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </el-form>


      <el-table :data="tableData"
                empty-text="無資料"
                stripe header-row-class-name="headerStyle"
                @selection-change="handleSelctionChange">

        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="custNo" label="客戶編號" width="80"></el-table-column>
        <el-table-column prop="name" label="客戶">
          <template slot-scope="props">
            <p><b>{{ props.row.company }}</b></p>
            <p>{{ props.row.name }}</p>
            <p>{{ props.row.phone1 }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="custType" label="身份別"></el-table-column>
        <el-table-column label="區域">
          <template slot-scope="props">
            {{props.row.area1Name}}/{{props.row.area2Name}}/{{props.row.area3Name}}
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">關　閉</el-button>
        <el-button type="primary" @click="setupSales()">確 定</el-button>
      </div>
    </el-dialog>
  </el-row>


</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";

export default {
  name: "SalesPickupCustomer",
  components: {
    Breadcrumb
  },
  data() {
    return {
      dw: '60%',
      dialogFormVisible: false,
      options: [{
        value: 'name',
        label: '依客戶名稱'
      }, {
        value: 'company',
        label: '依公司名稱'
      }, {
        value: 'phone',
        label: '依聯絡電話'
      }, {
        value: 'address',
        label: '依地址'
      }],
      tableData: [],
      areaOption1: [],
      areaOption2: [],
      areaOption3: [],
      keyword: '',
      queryField: '',
      pageNum: 1,
      pageSize: 100,
      total: 0,
      form: {
        area1: '',
        area2: '',
        area3: ''
      },
      customerChecked: [],
      salesId: '',
      currentCustomerData: []
    }
  },
  methods: {
    handleEdit(data) {

    },
    handleDelete(custId) {
      this.request.post("/customer/unset/" + custId).then(res => {
        if (res.code === '200') {
          this.findMyCustomer()
          this.showResult('success', '解除成功')
        } else {
          this.showResult('error', '解除失敗')
        }
      })
    },
    handleSelctionChange(val) {
      this.customerChecked = val
    },
    setupSales() {
      let ids = this.customerChecked.map(v => v.id)
      let data = {
        ids,
        salesId: this.salesId
      }
      this.request.post("/customer/set-sales", data).then(res => {
        this.dialogFormVisible = false
        if (res.code === '200') {
          this.findMyCustomer()
          this.showResult('success', '設定成功')
        } else {
          this.showResult('error', '設定成功失敗')
        }
      })
    },
    findMyCustomer() {
      this.currentCustomerData = []
      this.request.get(`/customer/my-customer?salesId=${this.salesId}&queryField=${this.queryField}&keyword=${this.keyword}`).then(res => {
        if (res.code === '200') {
          this.currentCustomerData = res.data
        } else {
          this.showResult('error', '取得客戶資料出錯')
        }
      })
    },
    pickCustomer() {
      this.dialogFormVisible = true
      this.loadArea1();
    },
    search() {
      this.findMyCustomer()
    },
    clearQuery() {
      this.queryField = ''
      this.keyword = ''
      this.findMyCustomer()
    },
    listArea2Customer() {
      this.request.get("/customer/find/area2/" + this.form.area2).then(res => {
        if (res.code === '200') {
          this.tableData = res.data
        } else {
          this.showResult('error', '取得客戶資料出錯')
        }
      })
    },
    listArea3Customer() {
      this.request.get("/customer/find/area3/" + this.form.area3).then(res => {
        if (res.code === '200') {
          this.tableData = res.data
        } else {
          this.showResult('error', '取得客戶資料出錯')
        }
      })
    },
    loadArea1() {
      this.request.get("/area/area1").then(res => {
        if (res.code === '200') {
          this.areaOption1 = res.data
        } else {
          this.showResult('error', '無法取得地區1資料')
        }
      })
    },
    loadArea2() {
      this.form.area2 = ''
      this.form.area3 = ''
      this.tableData = []
      this.request.get("/area/area2/" + this.form.area1).then(res => {
        if (res.code === '200') {
          this.areaOption2 = res.data
        } else {
          this.showResult('error', '無法取得地區2資料')
        }
      })
    },
    loadArea3() {
      this.form.area3 = ''
      this.tableData = []
      this.request.get("/area/area3/" + this.form.area2).then(res => {
        if (res.code === '200') {
          this.areaOption3 = res.data
          this.listArea2Customer()
        } else {
          this.showResult('error', '無法取得地區3資料')
        }
      })
    },
    setDialogWidth() {
      let windowSize = document.body.clientWidth;
      const defaultWidth = 700; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = "90%";
      } else {
        this.dw = "60%";
      }
    }

  },
  mounted() {
    this.salesId = this.$route.params.salesId
    this.findMyCustomer()
    // this.loadArea1()
    window.onresize = () => {
      return (() => {
        this.setDialogWidth();
      })();
    };
  }
}
</script>

<style scoped>
.el-table {
  border-radius: 10px;
  padding: 20px;
}

.el-table >>> .headerStyle {
  /*background-color: #1e8fc6;*/
}

.el-popover.el-popper .el-popconfirm {
  background-color: black !important;
  padding: 10px !important;
}

.avatar-uploader {
  /*border: 1px dashed #d9d9d9;*/
  /*border-radius: 6px;*/
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.display-avatar {
  width: 60px;
  height: 60px;
  border-radius: 999px;
}


/deep/ .el-upload-dragger {
  width: 180px !important;
}


</style>
